// 链接类型
export let linkTypes = [
  {
    label: '商品',
    value: 'GOODS'
  },
  {
    label: '报告',
    value: 'REPORT'
  },
  {
    label: '新闻',
    value: 'NEWS'
  },
  {
    label: '海报',
    value: 'POSTER'
  },
  {
    label: '视频',
    value: 'VIDEO'
  },
  {
    label: '活动',
    value: 'ACTION'
  },
  {
    label: '直播讲堂',
    value: 'LECTURE_LIVE'
  },
  {
    label: '视频讲堂',
    value: 'LECTURE_VIDEO'
  },
  {
    label: '其他',
    value: 'OTHER'
  }
]
// 链接目标来源
export let targetFroms = [
  {
    label: '生命银行移动C端',
    value: 'H5'
  },
  {
    label: '上市公司小程序',
    value: 'MINIAPP'
  }
]
